export interface ArtistData {
  id: string;
  name: string;
  displayName: string;
  bio: string;
  storyline: string;
  spotifyArtistId: string;
  spotifyUrl: string;
  appleMusicUrl?: string;
  youtubeMusicUrl?: string;
  instagramHandle: string;
  instagramUrl: string;
  tiktokHandle: string;
  tiktokUrl: string;
  soundcloudUrl?: string;
  email?: string;
  profileImage?: string;
  logoImage?: string;
  merchStoreUrl?: string;
  latestMerch?: {
    id: string;
    name: string;
    image: string;
    price?: string;
    url: string;
  }[];
}

export const artistsData: Record<string, ArtistData> = {
  aimusicdreams: {
    id: 'aimusicdreams',
    name: 'AIMusicDreams',
    displayName: 'AiMusicdreams',
    bio: 'AIMusicDreams är ett musikprojekt som blandar dansband, satir, raggarock, pop, trubadur och country — musik med svenska rötter och ett leende. Musiken är skapad med AI, men texterna är skrivna och produktionerna gjorda av Marcus Steiner.',
    storyline: 'Projektet utforskar vad som händer när AI möter genuint svenska genrer — från dansbandets taktfasta rytmer till raggarkulturens råa energi och troubadurens berättande. Varje spår är ett samarbete mellan mänsklig kreativitet och maskinintelligens. Distribuerat globalt via Spotify och Apple Music.',
    spotifyArtistId: '4mzl9kB6QtB7F2UZktujSY',
    spotifyUrl: 'https://open.spotify.com/artist/4mzl9kB6QtB7F2UZktujSY?si=Dl_Ky7l6SGqj8yw_f8k3mQ',
    appleMusicUrl: 'https://music.apple.com/artist/aimusicdreams',
    youtubeMusicUrl: 'https://www.youtube.com/channel/UCllbC3w3u0HLLgbY1GKNUHA',
    instagramHandle: '@aimusicdreams',
    instagramUrl: 'https://www.instagram.com/aimusicdreams/',
    tiktokHandle: '@aimusicdreams',
    tiktokUrl: 'https://www.tiktok.com/@aimusicdreams',
    soundcloudUrl: 'https://soundcloud.com/aimusicdreams',
    email: 'aimusicdreams@gmail.com',
    logoImage: '/AIMusicDreams-trasparent.png',
    merchStoreUrl: 'https://aimusicstore.com',
    latestMerch: [
      {
        id: '1',
        name: 'AI Dreams T-Shirt',
        image: '/placeholder.svg',
        price: '299 kr',
        url: 'https://aimusicstore.com/products/ai-dreams-tshirt'
      },
      {
        id: '2',
        name: 'Neural Network Hoodie',
        image: '/placeholder.svg',
        price: '599 kr',
        url: 'https://aimusicstore.com/products/neural-network-hoodie'
      }
    ]
  },
  idreamz: {
    id: 'idreamz',
    name: 'iDreamz',
    displayName: 'iDreamz',
    bio: 'iDreamz är ett hardstyle- och EDM-projekt med hög energi, distade kicks och hypnotiska melodier. Musiken är skapad med AI, men texterna är skrivna och produktionerna gjorda av Marcus Steiner. Perfekt för träning, gaming och stora scener.',
    storyline: 'iDreamz kombinerar hardstyle-produktionens råa kraft med generativa AI-verktyg — från 160 BPM kicks till atmosfäriska breakdowns. Varje spår är ett samarbete mellan Marcus Steiners kreativa vision och maskinintelligens, med målet att tänja på vad elektronisk musik kan vara.',
    spotifyArtistId: '4oueubAW8Q0Okox6prqH3F',
    spotifyUrl: 'https://open.spotify.com/artist/4oueubAW8Q0Okox6prqH3F?si=T7tK_ALxT5C58lwAKi9eJg',
    appleMusicUrl: 'https://music.apple.com/artist/idreamz',
    youtubeMusicUrl: 'https://www.youtube.com/channel/UCwMMB9QJN779qpCu13G-nWA',
    instagramHandle: '@idreamz.official',
    instagramUrl: 'https://www.instagram.com/idreamz.official',
    tiktokHandle: '@idreamzai',
    tiktokUrl: 'https://www.tiktok.com/@idreamzai',
    soundcloudUrl: 'https://soundcloud.com/aimusicdreams',
    email: 'idreamz.aimusic@gmail.com',
    logoImage: '/iDreamz_banner.png',
    merchStoreUrl: 'https://aimusicstore.com/idreamz',
    latestMerch: [
      {
        id: '3',
        name: 'Dreamz Cap',
        image: '/placeholder.svg',
        price: '249 kr',
        url: 'https://aimusicstore.com/products/dreamz-cap'
      },
      {
        id: '4',
        name: 'Digital Dreams Poster',
        image: '/placeholder.svg',
        price: '149 kr',
        url: 'https://aimusicstore.com/products/digital-dreams-poster'
      }
    ]
  }
};

export const getArtistData = (artistId: string): ArtistData | undefined => {
  return artistsData[artistId.toLowerCase()];
};

export const getAllArtists = (): ArtistData[] => {
  return Object.values(artistsData);
};